import { render, staticRenderFns } from "./ApostasdosSubordinados.vue?vue&type=template&id=26d7f4a2&scoped=true"
import script from "./ApostasdosSubordinados.vue?vue&type=script&lang=js"
export * from "./ApostasdosSubordinados.vue?vue&type=script&lang=js"
import style1 from "./ApostasdosSubordinados.vue?vue&type=style&index=1&id=26d7f4a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d7f4a2",
  null
  
)

export default component.exports